import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import {
  fetchStockAdjustmentDetail,
  fetchStockAdjustments,
  fetchStockAdjustmentSummary,
} from '@/renderer/services/inventoryStockAdjustmentService';
import type { StockAdjustmentFilterParams } from '@/renderer/types/inventory';

export function useStockAdjustments(params: StockAdjustmentFilterParams) {
  return useQuery({
    queryKey: queryKeys.inventory.stockAdjustmentsList(params),
    queryFn: () => fetchStockAdjustments(params),
    enabled: !!params.companyId && !!params.outletId,
    placeholderData: keepPreviousData,
  });
}

export function useStockAdjustmentDetail(
  companyId: number | null,
  adjustmentId: string | null,
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockAdjustmentDetail(
      companyId ?? 0,
      adjustmentId ?? '',
    ),
    queryFn: () => fetchStockAdjustmentDetail(adjustmentId!),
    enabled: !!companyId && !!adjustmentId,
  });
}

export function useStockAdjustmentSummary(
  companyId: number | null,
  outletId: string | null,
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockAdjustmentSummary(
      companyId ?? 0,
      outletId ?? '',
    ),
    queryFn: () => fetchStockAdjustmentSummary(companyId!, outletId!),
    enabled: !!companyId && !!outletId,
  });
}
